import { acceptOnlyValidOptionByLabel } from '../../field-viewer/shared-normalizers';
export const dextRadioGroupViewer = {
    normalizeLoadedValue: acceptOnlyValidOptionByLabel
};

//# sourceMappingURL=definition-viewer.js.map